<template>
  <Admin>
    <v-main v-if="!isProductListLoading" class="wrapper">
        <v-container v-if="!selectedCompanyProductList?.isFixedAssetCount" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
        ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
            <h1>Fixed Asset List</h1>
        </div>
        <v-divider/>
        <v-row justify="center">
          <v-col>              
            <asset-table 
              :data="assetList.length > 0 ? assetList : []"
              @syncNs="syncDataFromNetsuite"  
            ></asset-table>
          </v-col>
        </v-row>
        <v-row justify="start" class="tw-my-4">
          <v-col>
            <select class="items-per-page-selector" v-model="itemsPerPage">
              <option
                v-for="option in itemsPerPageOptions"
                :key="option"
                :value="option"
                :selected="option === itemsPerPage"
              >
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination v-model="currentPage" :length="numPages" :total-visible="10" @input="paginate"></v-pagination>
          </v-col>
          <v-col class="tw-flex tw-items-end tw-justify-end">
            <p class="total-item">จำนวนรายการทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
     <v-snackbar v-model="sysnSuccess" color="primary" top>
      ซิงค์ข้อมูลสำเร็จ
    </v-snackbar>
  </Admin>
</template>
<script >
import Admin from '@/components/admin/admin-main-template.vue'
import fc from "@/firebaseConfig"; 
import firebase from "firebase/app";
import "firebase/auth";
import {mapState, mapActions} from "vuex";
import AssetTable from '@/components/admin/fixedAssets/assetTable.vue';
const axios = require('axios');
const OAuth01 = require('oauth-1.0a');
const crypto = require('crypto');

export default {
    name: "fixedAssetCount",
    components: {
        Admin,
        AssetTable
    },
    data(){
        return { 
            fixedAssetCount: 0, 
            itemsPerPage: 10,
            currentPage: 1,
            displayedItems: [],
            itemsPerPageOptions: [10, 20, 30, 40, 50],
            headers: [
                { text: 'No.', value: 'no', width: '5%' },
                { text: 'Code', value: 'code', width: '15%' },
                { text: 'Name', value: 'name', width: '20%' },
                { text: 'Department', value: 'department', width: '15%' },
                { text: 'Location', value: 'location', width: '15%' },
                { text: 'Class', value: 'class', width: '15%' },
            ],
            items: [],
            loading: false,
            sysnSuccess: false,
        }
    },
    computed: {
        ...mapState({
           selectedCompanyProductList: (state) =>
          state.companies.selectedCompanyProductList,
          isProductListLoading: (state) => state.companies.isProductListLoading,
          assetList: (state) => state.fixedAssets.assetList,
          storeLoading: (state) => state.fixedAssets.isLoading
        }),
        numPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        },
        totalItems() {
            return this.assetList.length;
        },
    },
        methods: {
        ...mapActions({
            fetchAssetList: "fixedAssets/fetchAssetList",
            fetchDepartments: "fixedAssets/fetchDepartments",
            fetchLocations: "fixedAssets/fetchLocations",
            fetchAssetClasses: "fixedAssets/fetchAssetClasses",
            addNewAsset: "fixedAssets/addNewAsset",
            updateAsset: "fixedAssets/updateAsset",
            deleteAsset: "fixedAssets/deleteAsset",
            clearAllListeners: "fixedAssets/clearAllListeners"
        }), 
            async syncDataFromNetsuite() {
            // Set loading state
            this.loading = true;
            
            console.log('Syncing data from Netsuite...');
            this.$store.dispatch("setGlobalLoading", true);
            
            try {
                let token = await firebase.auth().currentUser.getIdToken(false);
                //  console.log('Firebase token:', token);
                
                const companyId = this.$route.params.companyId || localStorage.getItem("companyId");
                // console.log('Company ID being sent:', companyId);
                
                const response = await axios.get(
                    `${fc.cloudFunctionUrl}/apiFixedAssetNetsuite`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'companyID': companyId,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                if (response.status !== 200) {
                    throw new Error(`Error syncing data: ${response.statusText}`);
                }else {
                    this.sysnSuccess = true;
                }
                // console.log('Data synced successfully:', response.data);
                this.$store.dispatch("setGlobalLoading", false);
                this.loading = false;
                
            } catch (error) {
                console.error('Error syncing data:', error);
                this.$store.dispatch("setGlobalLoading", false);
                this.loading = false;
            }
        },
        
        editItem(item) {
            // Implement edit functionality
            console.log('Editing item:', item);
            
            // Example - You could show a dialog and then update
            const confirmed = confirm(`Do you want to edit ${item.name}?`);
            if (confirmed) {
                const companyId = this.$route.params.companyID || localStorage.getItem("companyId");
                // Sample edit - in real app this would come from a form
                const updatedData = {
                    assetName: item.name + ' (Updated)',
                    updatedAt: new Date()
                };
                
                this.updateAsset({
                    companyId,
                    assetId: item.id,
                    assetData: updatedData
                });
            }
        },
        
        deleteItem(item) {
            // Implement delete functionality
            if (confirm(`Are you sure you want to delete ${item.name}?`)) {
                const companyId = this.$route.params.companyID || localStorage.getItem("companyId");
                this.deleteAsset({
                    companyId,
                    assetId: item.id
                }).then(result => {
                    if (result.success) {
                        console.log('Asset deleted successfully');
                    } else {
                        console.error('Failed to delete asset:', result.error);
                    }
                });
            }
        },
        paginate() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = Number.parseInt(startIndex) +  Number.parseInt(this.itemsPerPage);

            if (startIndex != 0 && startIndex >= this.items.length) {
                // Reset to page 1 if the current page is out of range
                console.warn("Page exceeds available data. Resetting to page 1");
                this.currentPage = 1;
                this.paginate();  // Re-run pagination for page 1
            } else {
                // If the page is within range, slice the items as usual
                this.displayedItems = this.items.slice(startIndex, endIndex);
            }
        }
    },
    watch: {
        items: {
            handler() {
                this.paginate();
            },
            immediate: true,
        },
        itemsPerPage() {
            this.paginate();
            localStorage.setItem("pageLimit", this.itemsPerPage);
        },
        currentPage() {
            this.paginate();
        }, 
    },
    mounted() {
    this.itemsPerPage = Number.isNaN(Number.parseInt(localStorage.getItem("pageLimit"))) ? 10 : Number.parseInt(localStorage.getItem("pageLimit"));
    this.paginate();

    // Get the company ID (this should match how your app gets the current company)
    const companyId = this.$route.params.companyId ;
    console.log('Company ID:', companyId);
    if (companyId) {
        console.log('Fetching data for company:', companyId);
        // Fetch data from Firestore
        this.fetchAssetList({ companyId });
        // this.fetchDepartments({ companyId });
        // this.fetchLocations({ companyId });
        // this.fetchAssetClasses({ companyId });
    }
    },
    beforeDestroy() {
        // Clean up listeners when component unmounts
        this.clearAllListeners();
    },
};
</script>

<style scoped>
.items-per-page-selector {
  padding: 0.3rem .5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.total-item {
  margin-bottom: 0;
  font-size: 0.9rem;
}
</style>